export default {
  user(state) {
    return state.user;
  },
  token(state) {
    return state.token;
  },
  isAuthenticated(state) {
    return !!state.token;
  },
  profile(state) {
    return { name: state.name, email: state.email, address: state.address, phone: state.phone, type: state.type };
  }
};
